import { useAuth } from 'context/auth'
import ClickOutSide from 'hooks/click-outside'
import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { useT } from 'utils/i18n'

function ProfileButton() {
  const { currentUser, logout } = useAuth()
  const [openProfile, setOpenProfile] = useState(false)
  const { t } = useT()
  return (
    <div>
      <div>
        <button
          type="button"
          aria-haspopup='menu'
          aria-expanded={openProfile}
          className='flex rounded-full ring-1 ring-line focus-visible:outline focus-visible:outline-[3px] focus-visible:outline-offset-2 focus-visible:outline-focus'
          onClick={() => setOpenProfile(!openProfile)}
        >
          <span className='sr-only'>{t('Open user menu', 'افتح قائمة المستخدم')}</span>
          <img
            className='w-9 h-9 object-cover bg-soft rounded-full'
            src={currentUser.avatar || 'https://placehold.co/600x600'}
            alt="user"
          />
        </button>
      </div>
      <ClickOutSide onClickOutside={() => setOpenProfile(false)}>
        {openProfile && (
          // studio menu card
          <div role='menu' className='z-50 absolute end-4 md:end-7 top-[60px] min-w-[220px] max-w-[280px] bg-surface text-ink border border-line rounded-card shadow-lift divide-y divide-line overflow-hidden'>
            <div className='px-4 py-3' role='none'>
              <p className='text-[13px] font-semibold text-ink truncate' role='none'>
                {currentUser.fullname}
              </p>
              <p
                className='text-xs text-muted truncate'
                role='none'
              >
                {currentUser.email}
              </p>
            </div>
            <ul className='p-1.5' role='none'>
              <li>
                <Link
                  to="./profile"
                  className='block px-3 py-2 rounded-control text-[13px] text-ink hover:bg-action-wash cursor-pointer'
                  role="menuitem"
                  onClick={() => setOpenProfile(false)}
                >
                  {t('Profile', 'الملف الشخصي')}
                </Link>
              </li>

              <li>
                <a
                  role="menuitem"
                  tabIndex={0}
                  onKeyDown={(e) => e.key === 'Enter' && logout()}
                  onClick={logout}
                  className='block px-3 py-2 rounded-control text-[13px] text-ink hover:bg-action-wash cursor-pointer'
                >
                  {t('Sign out', 'تسجيل الخروج')}
                </a>
              </li>
            </ul>
          </div>
        )}
      </ClickOutSide>
    </div>
  )
}

export default ProfileButton
